/**
*  供货管理 供货关系管理
*/
<template>
  <div class="contianer">
    <!-- 订单提现 -->
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="我供货的" name="first">
          <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="">
              <el-date-picker
                v-model="searchDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline.seller_purchaser_name" clearable
                        placeholder="输入商家名称"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="formInline.audit_status" placeholder="审核状态" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option label="审核通过" value="261"></el-option>
                <el-option label="待审核" value="260"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="search">查询</el-button>
              <el-button size="small" type="success" @click="addButton" class="add-button">新增</el-button>
              <el-button size="small" type="warning" @click="exportExcel()">导出</el-button>
            </el-form-item>
          </el-form>
          <!--列表-->
          <div style="height: 550px;overflow-y: auto">
            <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                      @cell-dblclick="cellDbClick" element-loading-text="拼命加载中" style="width: 70%;">
              <el-table-column align="center" type="selection" width="80">
              </el-table-column>
              <el-table-column
                label="序号"
                width="60">
                <template slot-scope="scope">
                  {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column prop="seller_purchaser_name" label="商家名称" min-width="160" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="tax_rate" label="税率" width="100" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div v-if="scope.row.tax_rate||scope.row.tax_rate== ''">{{scope.row.tax_rate}}%</div>
                </template>
              </el-table-column>
              <el-table-column prop="create_time" label="创建时间" width="135">
              </el-table-column>
              <el-table-column prop="audit_status" label="商家审核状态" width="120">
                <template slot-scope="scope">
                  <div plain style="color: #409EFF" v-if="scope.row.audit_status=='260'">待审核</div>
                  <div plain style="color: #67c23a" v-else-if="scope.row.audit_status=='261'">审核通过</div>
                  <div plain style="color: #F56C6C" v-else>审核不通过</div>
                </template>
              </el-table-column>
              <el-table-column align="left" label="操作" width="160">
                <template slot-scope="scope"  v-if="scope.row.audit_status=='261'">
                  <el-button type="primary" size="mini" @click="lift(scope.row.seller_purchaser_id)">
                    解除供货关系
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
          <!-- 弹窗 -->
          <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
                     title="新增供货关系"
                     :visible.sync="editDialogVisible"
                     :before-close="handleClose"
                     width="30%"
                     center>
            <el-form label-width="120px" :model="flashForm" :rules="rules" ref="flashForm" class="flashForm">
              <el-form-item label="商家名称" prop="seller_purchaser_id">
                <el-select v-model="flashForm.seller_purchaser_id" filterable placeholder="请选择商家名称" clearable
                           remote :filter-method="remoteMethod" class="productInterval" :popper-append-to-body="false"
                           @focus="focusRuleName()" @change="changeRuleName()" @clear="clear()">
                  <el-option class="sellerList"
                             v-for="item in sellerList"
                             :key="item.seller_purchaser_id"
                             :label="item.seller_purchaser_name"
                             :value="item.seller_purchaser_id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="税率" prop="tax_rate">
                <el-select v-model="flashForm.tax_rate" placeholder="请选择税率" clearable>
                  <el-option v-for="item in rateList" :key="item.value" :label="item.name"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="sure('flashForm')" :disabled="!isCanSubmit">确 定</el-button>
              <el-button @click="handleClose">取 消</el-button>
            </span>
          </el-dialog>
        </el-tab-pane>

        <!-- 提现记录 -->
        <el-tab-pane label="给我供货" name="second" v-if="agent_type=='2891'">
          <el-form :inline="true" :model="formInline1" class="user-search">
            <el-form-item label="">
              <el-date-picker
                v-model="searchDate1"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline1.seller_supplier_name" clearable
                        placeholder="输入供应商名称"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="formInline1.audit_status" placeholder="处理状态" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option label="审核通过" value="261"></el-option>
                <el-option label="待审核" value="260"></el-option>
                <el-option label="审核未通过" value="262"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="search1">查询</el-button>
              <el-button size="small" type="warning" @click="exportExcel1()">导出</el-button>
            </el-form-item>
          </el-form>
          <!--列表-->
          <div style="height: 550px;overflow-y: auto">
            <el-table size="small" :data="listData1" highlight-current-row v-loading="loading" border
                      @cell-dblclick="cellDbClick" element-loading-text="拼命加载中" style="width: 60%;">
              <el-table-column align="center" type="selection" width="80">
              </el-table-column>
              <el-table-column
                label="序号"
                width="60">
                <template slot-scope="scope">
                  {{pageparm1.pageSize * (pageparm1.currentPage - 1) + (scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column prop="seller_supplier_name" label="供应商名称" min-width="160" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="create_time" label="创建时间" width="135">
              </el-table-column>
              <el-table-column prop="audit_status" label="商家审核状态" width="120">
                <template slot-scope="scope">
                  <div plain style="color: #409EFF" v-if="scope.row.audit_status=='260'">待审核</div>
                  <div plain style="color: #67c23a" v-else-if="scope.row.audit_status=='261'">审核通过</div>
                  <div plain style="color: #F56C6C" v-else>审核不通过</div>
                </template>
              </el-table-column>
              <el-table-column align="left" label="操作" width="160">
                <template slot-scope="scope" v-if="scope.row.audit_status=='260'">
                  <el-button type="success" size="mini"
                             @click="audit(scope.row.id,'261')">同意
                  </el-button>
                  <el-button type="danger" size="mini"
                             @click="audit(scope.row.id,'262')">拒绝
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <Pagination v-bind:child-msg="pageparm1" @callFather="callFather1"></Pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {
  purchaserSupplierExport,
  supplierPurchaserExport,
  supplierPurchaserList,
  purchaserSupplierList, supplierPurchaserName,
  supplierTerminate, supplierPurchaserAdd,
  purchaserSupplierAudit
} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {timestampToDate} from "../../utils/util";

  export default {
    data: () => {
      return {
        loading: false, // 是显示加载
        editDialogVisible: false, //控制页面显示与隐藏
        searchDate: '',
        searchDate1: '',
        formInline: {
          page: 1,
          rows: 10,
          begin_time: '',
          end_time: '',
          audit_status: '',
          seller_purchaser_name: ''
        },
        formInline1: {
          page: 1,
          rows: 10,
          begin_time: '',
          end_time: '',
          audit_status: '',
          seller_supplier_name: ''
        },
        tokenId: '',
        activeName: 'first',
        listData: [], //用户数据
        listData1: [], //用户数据
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页的数据条数
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        pageparm1: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        flashForm: {
          seller_purchaser_id: '',
          tax_rate: '',
          // seller_name: ''
        },
        // rules表单验证
        rules: {
          seller_purchaser_id: [{required: true, message: '请选择商家名称', trigger: 'blur'}],
          tax_rate: [{required: true, message: '请选择税率', trigger: 'blur'}],
          // seller_name: [{required: true, message: '请输入店铺名称', trigger: 'blur'}],
          agentType: [{required: true, message: '请选择供货身份', trigger: 'blur'}]
        },
        sellerList: [],
        isCanSubmit: true,
        confirmTip:'',
        agent_type: localStorage.getItem('agent_type')||'2891',
        rateList: [
          {
            name: '0%',
            value: 0
          }, {
            name: '1%',
            value: 1
          }, {
            name: '3%',
            value: 3
          }, {
            name: '6%',
            value: 6
          }, {
            name: '13%',
            value: 13
          }
        ],
        small: true,
        sellerName: '',
        selectedruleName: ''
      };
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getData(this.formInline)
      this.getData1(this.formInline1)
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表1-0
      getData() {
        this.loading = true
        supplierPurchaserList(this.formInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 新增
      addButton() {
        this.editDialogVisible = true;
        this.flashForm = {
          seller_purchaser_id: '',
          tax_rate: 13
        };
        this.getCouponRule()
      },
      getCouponRule(sellerName) {
        let param = {
          page: 1,
          rows: 10,
          seller_name: sellerName
        }
        supplierPurchaserName(param)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (!res.content.length) {
                this.selectedruleName = ''
              }
              this.sellerList = res.content;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      remoteMethod(val) {
        this.sellerName = val;
        this.getCouponRule(val)
      },
      focusRuleName() {
        if (!this.selectedruleName) {
          this.sellerName = ''
          this.getCouponRule('')
        }
      },
      changeRuleName() {
        this.sellerList.forEach((item) => {
          if (item.seller_purchaser_id == this.flashForm.seller_purchaser_id) {
            this.selectedruleName = item.seller_purchaser_name;
            this.getCouponRule(item.seller_purchaser_name)
          }
        })
      },
      clear() {
        this.getCouponRule()
        this.sellerName = ''
      },
      handleClose() {
        this.$refs["flashForm"].resetFields();
        this.editDialogVisible = false;
      },
      sure(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            supplierPurchaserAdd(this.flashForm)
              .then(res => {
                this.isCanSubmit = true;
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '保存成功!'
                  })
                  this.editDialogVisible = false;
                  this.getData()
                }
              })
              .catch(err => {
                this.isCanSubmit = true;
                this.loading = false
                this.$message.error('网络错误,请稍后再试!')
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getData(this.formInline)
      },
      // 获取公司列表1-1
      getData1() {
        this.loading = true
        purchaserSupplierList(this.formInline1)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData1 = res.content.rows
              // 分页赋值
              this.pageparm1.currentPage = this.formInline1.page
              this.pageparm1.pageSize = this.formInline1.rows
              this.pageparm1.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather1(parm) {
        this.formInline1.page = parm.currentPage
        this.formInline1.rows = parm.pageSize
        this.getData1(this.formInline1)
      },
      // 搜索事件
      search() {
        if (this.searchDate) {
          this.formInline.begin_time = timestampToDate(this.searchDate[0])
          this.formInline.end_time = timestampToDate(this.searchDate[1])
        } else {
          this.formInline.begin_time = ''
          this.formInline.end_time = ''
        }
        this.formInline.page = 1;
        this.getData(this.formInline)
      },
      search1() {
        if (this.searchDate1) {
          this.formInline1.begin_time = timestampToDate(this.searchDate1[0])
          this.formInline1.end_time = timestampToDate(this.searchDate1[1])
        } else {
          this.formInline1.begin_time = ''
          this.formInline1.end_time = ''
        }
        this.formInline1.page = 1;
        this.getData1(this.formInline1)
      },
      handleClick(tab, event) {
        console.log(tab.index)
        if (tab.index == 0) {
          this.getData(this.formInline)
        } else if (tab.index == 1) {
          this.getData1(this.formInline1)
        }
      },
      checkDate(date) {
        if (/^(\d{4})-(\d{2})-(\d{2})$/.test(date)) {
          return true
        } else {
          return false
        }
      },
      //每页条数改变时触发 选择一页显示多少行
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
      },
      handleSizeChange1(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
      },
      handleSizeChange2(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
      },
      //当前页改变时触发 跳转其他页
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
      },
      handleCurrentChange1(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
      },
      handleCurrentChange2(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
      },
      // 导出
      exportExcel() {
        supplierPurchaserExport(this.formInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url;
              link.setAttribute('download', '我供货的供应商信息.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 导出明细
      exportExcel1() {
        purchaserSupplierExport(this.formInline1)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url;
              link.setAttribute('download', '给供货的供应商信息.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      lift(seller_purchaser_id) {
        this.$confirm('是否确认解除供货关系？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let body = {
              seller_purchaser_id: seller_purchaser_id
            }
            supplierTerminate(body).then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '已成功解除供货关系'
                })
                this.getData(this.formInline)
              }
            })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      },
      audit(id, audit_status) {
        if(audit_status=='261') {
          this.confirmTip = '是否同意该供货商的申请？'
        } else {
          this.confirmTip = '是否拒绝该供货商的申请？'
        }
        this.$confirm(this.confirmTip, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let body = {
              id:id,
              audit_status: audit_status
            }
            this.loading = true;
            purchaserSupplierAudit(body).then(res => {
              this.loading = false;
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                if(audit_status == '261') {
                  this.$message({
                    type: 'success',
                    message: '已同意该供货商的申请'
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '已拒绝该供货商的申请'
                  })
                }
                this.getData1(this.formInline1)
              }
            })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.seller_purchaser_name == cell.innerText || row.seller_supplier_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
    }
  };
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .textarea .el-textarea__inner {
    height: 120px;
    width: 320px;
    resize: none;
  }

  /deep/ .flashForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .flashForm .el-input--small {
    width: 320px;
  }

  .sellerList {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 320px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/views/supply/supplyRelationship.vue